import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import withTranslations from '@wheelbox/lithejs-i18n';
import {
  FeatherIcon,
  ZapIcon,
  Code2Icon,
  PackageIcon,
  GaugeIcon,
  SparklesIcon,
} from '@wheelbox/lithejs-lucide';

import { SectionHeading } from '@components/shared';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from '@wheelbox/lithejs-ui';

export interface FeaturesSectionProps {
  id?: string;
  testId?: string;
}

const featureIcons = {
  lightweight: FeatherIcon,
  typescript: Code2Icon,
  functional: SparklesIcon,
  zeroDeps: PackageIcon,
  fast: ZapIcon,
  simple: GaugeIcon,
};

const FeaturesSection: LitheFC<FeaturesSectionProps> = ({
  id = 'features-section',
  testId = 'features-section',
}): LitheElement<'section'> => {
  const t = withTranslations('Home');

  const features = [
    'lightweight',
    'typescript',
    'functional',
    'zeroDeps',
    'fast',
    'simple',
  ] as const;

  return [
    'section',
    {
      id,
      'data-testid': testId,
      class: 'py-20 px-4 bg-muted/50',
    },
    [
      'div',
      { class: 'max-w-6xl mx-auto' },
      SectionHeading({
        id: `${id}-heading`,
        title: t('features.title'),
        subtitle: t('features.subtitle'),
      }),
      [
        'div',
        { class: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' },
        ...features.map((feature, index) => {
          const Icon = featureIcons[feature];
          return Card(
            {
              id: `${id}-card-${index}`,
              classes: 'hover:shadow-lg transition-shadow',
            },
            CardHeader(
              {},
              [
                'div',
                { class: 'flex items-center gap-3 mb-2' },
                [
                  'div',
                  { class: 'p-2 rounded-lg bg-primary/10' },
                  Icon({ size: 24, classes: 'text-primary' }),
                ],
              ],
              CardTitle({}, t(`features.items.${feature}.title`)),
              CardDescription({}, t(`features.items.${feature}.description`))
            )
          );
        }),
      ],
    ],
  ];
};

export default FeaturesSection;
